import React from 'react';
import { Table, DropdownSort, DropdownItem } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';

const CheckoutTab = ({ sort, ordering }) => {
    const { t } = useTranslation();
    const ascending = t('ticket.common.ordering.ascending');
    const descending = t('ticket.common.ordering.descending');

    const SortHeaders = React.useMemo(() => {
        return [
            {
                label: 'session_number',
                name: 'crst',
                items: [
                    { key: 1, label: ascending, sort: 'crst' },
                    { key: 2, label: descending, sort: '-crst' }
                ]
            },
            {
                label: 'operator',
                name: 'alpha',
                items: [
                    { key: 1, label: t('fromRateCategory', { min: 'A', max: 'Z' }), sort: 'alpha' },
                    { key: 2, label: t('fromRateCategory', { min: 'Z', max: 'A' }), sort: '-alpha' }
                ]
            },
            {
                label: 'debut_date',
                name: 'start_date',
                items: [
                    { key: 1, label: ascending, sort: 'start_date' },
                    { key: 2, label: descending, sort: '-start_date' }
                ]
            },
            {
                label: 'end_date',
                name: 'end_date',
                items: [
                    { key: 1, label: ascending, sort: 'end_date' },
                    { key: 2, label: descending, sort: '-end_date' }
                ]
            }
        ];
    }, []);

    return (
        <Table.THead>
            <Table.Tr>
                {SortHeaders.map(st => {
                    return (
                        <th key={st.id}>
                            <DropdownSort
                                label={t(`ticket.checkout.tab_header.${st.label}`)}
                                active={[st.name, `-${st.name}`].includes(ordering)}
                                name={st.name}
                                ordering={ordering}
                                items={st.items.map(it => {
                                    return <DropdownItem.Icons key={it.key} item={it.label} checked={ordering === it.sort} onClick={() => sort(it.sort)} />;
                                })}
                            />
                        </th>
                    );
                })}
                <th>{t('ticket.checkout.tab_header.status')}</th>
                <th>{t('ticket.checkout.tab_header.actions')}</th>
            </Table.Tr>
        </Table.THead>
    );
};

export default CheckoutTab;
